<template>
    <div>
        <div class="title">
            <h3>Os campos com * são de preenchimento obrigatório</h3>
            <h5>Caso queira, você poderá salvar e continuar depois.</h5>
        </div>
        <div class="formulario">
            <div class="agrupamentoFormulario">
                <div class="categoriaAgrupamentoFormulario">
                    <LabelDisclaimer :TamanhoFonteLabel="'H5'" :NomeLabel="'Dados da empresa'"
                        :TipoCliente="'Pessoa Jurídica'" :Sessao="'Dados da Empresa'" :SubSessao="'Dados da Empresa'" />
                </div>
                <div class="camposAgrupamentoFormulario">
                    <div class="row">
                        <div class="label__field" style="width: 40%">
                            <label class="label" for="razaoSocial">Razão social*</label>
                            <input class="field" type="text" id="razaoSocial" v-model="localPJ.Nome" disabled="true"
                                placeholder="Empresa X LTDA">
                        </div>
                        <div class="label__field" style="width: 40%">
                            <label class="label" for="cnpj">CNPJ*</label>
                            <input class="field" type="text" id="cnpj" v-model="localPJ.Cnpj" disabled="true"
                                placeholder="12.345.678/0001-10">
                        </div>
                        <div class="label__field" style="width: 20%" v-if="configuracaoApelido == 'S'">
                            <div style="display: flex;">
                                <label class="label" for="apelido">Apelido*</label>
                                <i class="fa fa-info-circle info-icon"
                                    title="O apelido deve ter entre 3 e 20 caracteres, podendo incluir letras (maiúsculas ou minúsculas) e números. Não é permitido o uso de caracteres especiais."></i>
                            </div>
                            <input class="field" type="text" id="apelido" v-model="localPJ.Apelido"
                                @input="validarApelido" @blur="checkApelidoLength" @change="salvarAlteracoesLocalmente">
                            <input type="hidden" id="apelidoOriginal" v-model="localPJ.ApelidoOriginal">
                            <p v-if="apelidoError" class="erro">{{ apelidoError }}</p>
                            <p v-if="camposObrigatorios.erroApelido" class="erro">
                                Campo obrigatório.
                            </p>
                        </div>
                    </div>
                    <div class="row">
                        <div class="label__field" style="width: 33%">
                            <label class="label" for="dataConstituicao">Data de constituição*</label>
                            <input class="field" type="date" id="nome" @change="salvarAlteracoesLocalmente"
                                v-model="localPJ.DataConstituicao" placeholder="00/00/0000">
                            <p v-if="camposObrigatorios.erroDataConstituicao" class="erro">Campo obrigatório.</p>
                        </div>
                        <div class="label__field" style="width: 33%">
                            <label class="label" for="numeroNIRE">Número NIRE</label>
                            <input class="field" type="text" id="numeroNIRE" @change="salvarAlteracoesLocalmente"
                                v-model="localPJ.NumeroNire" placeholder="">
                        </div>
                        <div class="label__field" style="width: 40%">
                            <label class="label" for="atividadePrincipal">Atividade principal*</label>

                            <!--<select id="atividadePrincipal" @change="salvarAlteracoesLocalmente" class="field"
                                v-model="localPJ.AtividadePrincipal">
                                <option v-for="(item, index) in listaAtividades" :key="item" :value="index">
                                    {{ item }}
                                </option>
                            </select>
                            -->

                            <multiselect id="atividadePrincipal" v-model="selectedAtividade" :options="listaAtividades"
                                :custom-label="formatAtividade" label="descricao" track-by="id" @select="handleSelect">
                            </multiselect>

                        </div>
                    </div>
                    <div class="row">
                        <div class="label__field" style="width: 50%">
                            <label class="label" for="tipoInvestidor">Tipo de Investidor*</label>
                            <select id="tipoInvestidor" @change="salvarAlteracoesLocalmente" class="field"
                                v-model="localPJ.TipoInvestidorId">
                                <option v-for="(item) in listaTiposInvestidores" :key="item.Descricao" :value="item.Id">
                                    {{ item.Descricao.substring(0, 150) }}
                                </option>
                            </select>
                            <p v-if="camposObrigatorios.erroTipoInvestidor" class="erro">Campo obrigatório.</p>
                        </div>
                        <div class="label__field" style="width: 50%">
                            <label class="label" for="tipoCliente">Tipo do Cliente*</label>
                            <select id="tipoCliente" @change="salvarAlteracoesLocalmente" class="field"
                                v-model="localPJ.TipoClientePJId">
                                <option v-for="(item) in listaTiposClientes" :key="item.Descricao" :value="item.Id">
                                    {{ item.Descricao }}
                                </option>
                            </select>
                            <p v-if="camposObrigatorios.erroTipoCliente" class="erro">Campo obrigatório.</p>
                        </div>
                    </div>
                    <div class="row">
                        <div class="label__field" style="width: 50%">
                            <label class="label" for="nome">Telefone*</label>
                            <input class="field" type="text" @change="salvarAlteracoesLocalmente"
                                v-mask="'(##) #####-####'" v-model="localPJ.Telefone" id="telefone"
                                placeholder="+55 (00) 0000-0000">
                            <p v-if="camposObrigatorios.erroTelefone" class="erro">Campo obrigatório.</p>
                        </div>
                        <div class="label__field" style="width: 50%" v-if="configuracaoTelefone2 == 'S'">
                            <label class="label" for="cpf">Telefone 2</label>
                            <input class="field" @change="salvarAlteracoesLocalmente" v-mask="'(##) #####-####'"
                                v-model="localPJ.Telefone2" type="text" id="telefone2" placeholder="+55 (00) 0000-0000">
                        </div>
                    </div>
                    <div class="row">
                        <div class="label__field" style="width: 50%">
                            <label class="label" for="nome">E-mail principal*</label>
                            <input class="field" disabled="true" v-model="localPJ.Email" type="text"
                                id="emailPrincipal">
                            <p v-if="camposObrigatorios.erroEmail" class="erro">Campo obrigatório.</p>
                        </div>
                        <div class="label__field" style="width: 50%">
                            <label class="label" for="cpf">E-mail secundário</label>
                            <input class="field" @change="salvarAlteracoesLocalmente" v-model="localPJ.EmailSecundario"
                                type="text" id="emailSecundario" @blur="validarEmailOnBlur">
                            <p v-if="mensagemErro" class="erro">{{ mensagemErro }}</p>
                        </div>
                    </div>
                    <div class="row">
                        <div class="label__field" style="width: 47%">
                            <label class="label" for="nome">Forma de Constituição*</label>
                            <!-- <div class="radio">
                                <input type="radio" id="s.a." value="s.a." name="constituicaoRadio" class="field__radio"
                                    @change="atualizarFormaConstituicao('s.a.')" v-model="localPJ.FormaConstituicao" />
                                <label for="s.a." class="label__radio">S.A.</label>
                                <input type="radio" id="ltda" value="ltda" name="constituicaoRadio" class="field__radio"
                                    @change="atualizarFormaConstituicao('ltda')" v-model="localPJ.FormaConstituicao" />
                                <label for="LTDA" class="label__radio">LTDA</label>
                                <input type="radio" id="outros" value="outros" name="constituicaoRadio"
                                    class="field__radio" @change="atualizarFormaConstituicao('outros')"
                                    v-model="localPJ.FormaConstituicao" />
                                <label for="Outros" class="label__radio">Outros</label>
                            </div> -->
                            <select class="field" v-model="localPJ.FormaConstituicao"
                                @change="salvarAlteracoesLocalmente">
                                <option value=""></option>
                                <option value="2">S. A.</option>
                                <option value="3">Limitada</option>
                                <option value="4">Sociedade de Capital e Indústria</option>
                                <option value="5">Assoc. Civil (Ent. Soc./Clube/Igreja/Fund.)</option>
                                <option value="6">Sociedade Comandita por Ações</option>
                                <option value="7">Sociedade Civil com Fins Lucrativos</option>
                                <option value="8">Sociedade em Conta Participação</option>
                                <option value="9">Cooperativa Rural/de Crédito/Habit.</option>
                                <option value="10">Filial/Sucursal/Ag. Empr. Sediada no Exterior</option>
                                <option value="11">Empresa Pública</option>
                            </select>
                        </div>
                        <p v-if="camposObrigatorios.erroFormaConstituicao" class="erro">Campo obrigatório.</p>
                    </div>
                    <!--<div class="row">
                        <div class="label__field" style="width: 100%">
                            <label class="label" for="nome">Se outros, especifique</label>
                            <textarea @change="salvarAlteracoesLocalmente" v-model="localPJ.OutrosDescricao"
                                style="width: 100%; height: 80px; max-height: 120px;" class="field"
                                :disabled="localPJ.FormaConstituicao !== 'outros'"></textarea>
                        </div>
                    </div>-->
                </div>
            </div>
            <div class="agrupamentoFormulario">
                <div class="categoriaAgrupamentoFormulario">
                    <LabelDisclaimer :TamanhoFonteLabel="'H5'"
                        :NomeLabel="'Empresas coligadas, controladas ou controladoras'" :TipoCliente="'Pessoa Jurídica'"
                        :Sessao="'Dados da Empresa'" :SubSessao="'Empresas Coligadas, Controladas e Controladoras'" />
                </div>
                <div class="camposAgrupamentoFormulario">
                    <div v-for="(empresa, index) in empresas" :key="empresa.Guid" class="empresaItem"
                        style="  border-bottom: 1px solid #EAECF0; margin-bottom: 20px;">
                        <div class="row">
                            <LabelDisclaimer :TamanhoFonteLabel="'H5'" :NomeLabel="`Empresa ${index + 1}`" />
                        </div>
                        <div class="row">
                            <div class="label__field" style="width: 80%">
                                <label class="label" for="nome">Tipo da empresa*</label>
                                <div class="radio">
                                    <input type="radio" :id="`tipoEmpresa_coligada_${index}`" value="Coligada"
                                        :name="`tipoEmpresa_coligada_${index}`" class="field__radio"
                                        v-model="empresa.Tipo" @change="salvarAlteracoesLocalmenteEmpresa" />
                                    <label :for="`tipoEmpresa_coligada_${index}`" class="label__radio">Coligada</label>
                                    <input type="radio" :id="`tipoEmpresa_controlada_${index}`" value="Controlada"
                                        :name="`tipoEmpresa_controlada_${index}`" class="field__radio"
                                        v-model="empresa.Tipo" @change="salvarAlteracoesLocalmenteEmpresa" />
                                    <label :for="`tipoEmpresa_controlada_${index}`"
                                        class="label__radio">Controlada</label>
                                    <input type="radio" :id="`tipoEmpresa_controladora_${index}`" value="Controladora"
                                        :name="`tipoEmpresa_controladora_${index}`" class="field__radio"
                                        v-model="empresa.Tipo" @change="salvarAlteracoesLocalmenteEmpresa" />
                                    <label :for="`tipoEmpresa_controladora_${index}`"
                                        class="label__radio">Controladora</label>
                                </div>
                            </div>
                            <div class="label__field" style="width: 20%; margin-top: 20px">
                                <a @click.stop.prevent="excluirEmpresa(index)" class="ico__delete"
                                    title="Excluir empresa">
                                    <Icon icon="ico-delete" />
                                </a>
                            </div>
                        </div>
                        <div class="row">
                            <div class="label__field" style="width: 50%">
                                <label class="label" for="nome">Razão social*</label>
                                <input class="field" type="text" @change="salvarAlteracoesLocalmenteEmpresa"
                                    id="RazaoSocialTipoEmpresa" v-model="empresa.RazaoSocial">
                                <p v-if="camposObrigatoriosEmpresa[index]?.erroRazaoSocial && tentativaPostagem"
                                    class="erro">Campo obrigatório.</p>
                            </div>
                            <div class="label__field" style="width: 50%">
                                <label class="label" for="cpf">CNPJ*</label>
                                <input class="field" type="text" @change="salvarAlteracoesLocalmenteEmpresa"
                                    id="CNPJTipoEmpresa" v-model="empresa.Cnpj">
                                <p v-if="camposObrigatoriosEmpresa[index]?.erroCnpj && tentativaPostagem" class="erro">
                                    Campo obrigatório.</p>
                            </div>
                        </div>
                    </div>
                    <div class="buttonsAcoes">
                        <button class="btnDefault" @click="addEmpresa">+ Adicionar empresa</button>
                    </div>
                </div>
            </div>
            <div class="agrupamentoFormulario">
                <div class="categoriaAgrupamentoFormulario">
                    <LabelDisclaimer :TamanhoFonteLabel="'H5'" :NomeLabel="'Sócios e Acionistas'"
                        :TipoCliente="'Pessoa Jurídica'" :Sessao="'Dados da Empresa'"
                        :SubSessao="'Sócios e Acionistas'" />
                </div>
                <div class="camposAgrupamentoFormulario">
                    <div v-for="(socio, index) in socios" :key="socio.Guid" class="socioItem"
                        style="border-bottom: 1px solid #EAECF0; margin-bottom: 20px;">
                        <div class="row">
                            <LabelDisclaimer :TamanhoFonteLabel="'H5'" :NomeLabel="`Sócio ${index + 1}`" />
                        </div>
                        <div class="row">
                            <div class="label__field" style="width: 33%">
                                <label class="label" for="nomeCompletoSocio_1">Nome*</label>
                                <input class="field" type="text" @change="salvarAlteracoesLocalmenteSocios"
                                    v-model="socio.Nome" id="nomeCompletoSocio_1" placeholder="Nome completo">
                                <p v-if="camposObrigatoriosSocio[index]?.erroNome && tentativaPostagem" class="erro">
                                    Campo obrigatório.</p>
                            </div>
                            <div class="label__field" style="width: 33%">
                                <label class="label" for="CpfCnpjSocio_1">CPF/CNPJ/Outros*</label>
                                <input class="field" type="text" @change="salvarAlteracoesLocalmenteSocios"
                                    v-model="socio.CpfCnpj" id="CpfCnpjSocio_1">
                                <p v-if="camposObrigatoriosSocio[index]?.erroCpfCnpj && tentativaPostagem" class="erro">
                                    Campo obrigatório.</p>
                            </div>
                             <div class="label__field" style="width: 33%">
                                <label class="label" for="TelefoneSocio_1">Telefone*</label>
                                <input class="field" type="text" @change="salvarAlteracoesLocalmenteSocios"
                                v-mask="celularMask" v-model="socio.Telefone" id="TelefoneSocio_1">
                                <p v-if="camposObrigatoriosSocio[index]?.erroTelefone && tentativaPostagem" class="erro">
                                    Campo obrigatório.</p>
                            </div>
                        </div>
                        <div class="row">
                            <div class="label__field" style="width: 50%">
                                <label class="label" for="emailSocio_1">E-mail*</label>
                                <input class="field" type="text" @change="salvarAlteracoesLocalmenteSocios"
                                    v-model="socio.Email" id="emailSocio_1">
                                <p v-if="camposObrigatoriosSocio[index]?.erroEmail && tentativaPostagem" class="erro">
                                    Campo obrigatório.</p>
                            </div>
                            <div class="label__field" style="width: 50%">
                                <label class="label" for="porcentagemParticipacaoSocio_1">% de Participação*</label>
                                <input class="field" type="text" @change="salvarAlteracoesLocalmenteSocios"
                                    v-model="socio.Percentual" id="porcentagemParticipacaoSocio_1" placeholder="50">
                                <p v-if="camposObrigatoriosSocio[index]?.erroPercentual && tentativaPostagem"
                                    class="erro">Campo obrigatório.</p>
                            </div>
                        </div>
                        <div class="row">
                            <div class="label__field" style="width: 15%">
                                <label class="label" for="cep">CEP*</label>
                                <input class="field" type="text" id="cep" placeholder="" v-model="socio.Cep"
                                    @change="validarCep">
                                <p v-if="camposObrigatoriosSocio[index]?.erroCep && tentativaPostagem" class="erro">
                                    Campo obrigatório.
                                </p>
                            </div>
                            <div style="width: 10%; margin-top: 35px;">
                                <a target="_blank" class="custom-link"
                                    href="https://buscacepinter.correios.com.br/app/endereco/index.php">Não sei o
                                    CEP</a>
                            </div>
                            <div class="label__field" style="width: 70%">
                                <label class="label" for="endereco">Endereço/Logradouro*</label>
                                <input class="field" type="text" :disabled="isDisabledEndereco" id="endereco"
                                    v-model="socio.Logradouro" placeholder=""
                                    @change="salvarAlteracoesLocalmenteSocios">
                                <p v-if="camposObrigatoriosSocio[index]?.erroLogradouro && tentativaPostagem"
                                    class="erro">
                                    Campo obrigatório.</p>
                            </div>
                            <div class="label__field" style="width: 10%">
                                <label class="label" for="logradouroNumero">Número*</label>
                                <input class="field" type="text" id="logradouroNumero"
                                    @change="salvarAlteracoesLocalmenteSocios" v-model="socio.LogradouroNumero"
                                    placeholder="">
                                <p v-if="camposObrigatoriosSocio[index]?.erroLogradouroNumero && tentativaPostagem"
                                    class="erro">
                                    Campo obrigatório.
                                </p>
                            </div>
                        </div>
                        <div class="row">
                            <div class="label__field" style="width: 40%">
                                <label class="label" for="complemento">Complemento</label>
                                <input class="field" type="text" @change="salvarAlteracoesLocalmenteSocios"
                                    v-model="socio.LogradouroComplemento" id="complemento" placeholder="">
                            </div>
                            <div class="label__field" style="width: 30%">
                                <label class="label" for="bairro">Bairro*</label>
                                <input class="field" type="text" :disabled="isDisabledEndereco" v-model="socio.Bairro"
                                    id="bairro" placeholder="" @change="salvarAlteracoesLocalmenteSocios">
                                <p v-if="camposObrigatoriosSocio[index]?.erroBairro && tentativaPostagem" class="erro">
                                    Campo obrigatório.</p>
                            </div>
                            <div class="label__field" style="width: 30%">
                                <label class="label" for="cidade">Cidade</label>
                                <input class="field" type="text" :disabled="isDisabledEndereco" v-model="socio.Cidade"
                                    id="cidade" placeholder="" @change="salvarAlteracoesLocalmenteSocios">
                                <p v-if="camposObrigatoriosSocio[index]?.erroCidade && tentativaPostagem" class="erro">
                                    Campo obrigatório.</p>
                            </div>
                        </div>
                        <div class="row">
                            <div class="label__field" style="width: 5%">
                                <label class="label" for="uf">UF*</label>
                                <input class="field" type="text" :disabled="isDisabledEndereco" id="uf"
                                    v-model="socio.Uf" placeholder="" @change="salvarAlteracoesLocalmenteSocios">
                                <p v-if="camposObrigatoriosSocio[index]?.erroUf && tentativaPostagem" class="erro">
                                    Campo obrigatório.</p>
                            </div>
                            <div class="label__field" style="width: 20%">
                                <label class="label" for="pais">País*</label>
                                <input class="field" type="text" :disabled="isDisabledEndereco" id="pais"
                                    v-model="socio.Pais" placeholder="" @change="salvarAlteracoesLocalmenteSocios">
                                <p v-if="camposObrigatoriosSocio[index]?.erroPais && tentativaPostagem" class="erro">
                                    Campo obrigatório.</p>
                            </div>
                            <div class="label__field" style="width: 20%">
                                <label class="label">É considerado US PERSON?*</label>
                                <div class="radio">
                                    <input type="radio" id="false" value="false" :name="`usPerson_${index}`"
                                        class="field__radio" v-model="socio.UsPerson"
                                        @change="salvarAlteracoesLocalmenteSocios" />
                                    <label for="Nao" class="label__radio">Não</label>
                                    <input type="radio" id="true" value="true" :name="`usPerson_${index}`"
                                        class="field__radio" v-model="socio.UsPerson"
                                        @change="salvarAlteracoesLocalmenteSocios" />
                                    <label for="Sim" class="label__radio">Sim</label>
                                </div>
                            </div>
                            <div class="label__field" style="width: 25%">
                                <label class="label">É uma Pessoa Exposta Politicamente?*</label>
                                <div class="radio">
                                    <input type="radio" id="false" value="false" :name="`pessoaExposta_${index}`"
                                        class="field__radio" v-model="socio.PoliticamenteExposta"
                                        @change="salvarAlteracoesLocalmenteSocios" />
                                    <label for="Nao" class="label__radio">Não</label>
                                    <input type="radio" id="true" value="true" :name="`pessoaExposta_${index}`"
                                        class="field__radio" v-model="socio.PoliticamenteExposta"
                                        @change="salvarAlteracoesLocalmenteSocios" />
                                    <label for="Sim" class="label__radio">Sim</label>
                                </div>
                            </div>
                            <div class="label__field" style="width: 29%">
                                <label class="label">Assinatura*</label>
                                <select class="field" v-model="socio.Assinatura"
                                    @change="salvarAlteracoesLocalmenteSocios">
                                    <option value=""></option>
                                    <option value="1">Não assina pela empresa</option>
                                    <option value="2">Assina isoladamente</option>
                                    <option value="0">Assina em conjunto</option>
                                </select>
                                <p v-if="camposObrigatoriosSocio[index]?.erroAssinatura && tentativaPostagem"
                                    class="erro">Campo obrigatório.</p>
                            </div>
                        </div>
                        <div class="row">
                            <div class="label__field" style="width: 50%">
                                <label class="label">RENDA MENSAL*</label>
                                <p class="sub-label">Soma dos salários, pró-labore, honoráros, pensão e/ou
                                    aposentadoria de todos os titulares conjuntamente.</p>
                                <select class="field" v-model="socio.RendaMensal"
                                    @change="salvarAlteracoesLocalmenteSocios">
                                    <option value=""></option>
                                    <option value="1">Nenhum</option>
                                    <option value="2">Até R$ 5.000</option>
                                    <option value="3">De R$ 5.001 até R$ 10.000</option>
                                    <option value="4">De R$ 10.001 até R$ 30.000</option>
                                    <option value="5">De R$ 30.001 até R$ 50.000</option>
                                    <option value="6">De R$ 50.001 até R$ 100.000</option>
                                    <option value="7">Acima de R$ 100.001</option>
                                </select>
                                <p v-if="camposObrigatoriosSocio[index]?.erroRendaMensal && tentativaPostagem"
                                    class="erro">Campo obrigatório.</p>
                            </div>
                            <div class="label__field" style="width: 50%">
                                <label class="label">PATRIMÔNIO TOTAL*</label>
                                <p class="sub-label">Soma da situação patrimonial de todos os titulares
                                    conjuntamente.</p>
                                <select class="field" v-model="socio.PatrimonioTotal"
                                    @change="salvarAlteracoesLocalmenteSocios">
                                    <option value=""></option>
                                    <option value="1">Nenhum</option>
                                    <option value="2">Até R$ 5.000</option>
                                    <option value="3">De R$ 5.001 até R$ 10.000</option>
                                    <option value="4">De R$ 10.001 até R$ 30.000</option>
                                    <option value="5">De R$ 30.001 até R$ 50.000</option>
                                    <option value="6">De R$ 50.001 até R$ 100.000</option>
                                    <option value="7">Acima de R$ 100.001</option>
                                </select>
                                <p v-if="camposObrigatoriosSocio[index]?.erroPatrimonioTotal && tentativaPostagem"
                                    class="erro">Campo obrigatório.</p>
                            </div>
                        </div>
                        <div class="row">
                            <div class="label__field" style="width: 50%">
                                <label class="label" for="outrosRendimentos">Outros Rendimentos - Anual (R$)
                                    (bonificações, dividendos, juros, etc.)</label>

                            <input class="field" v-model="socio.OutrosRendimentos" type="text" id="nome"
                                @change="salvarAlteracoesLocalmenteSocios" @blur="() => focusOut('OutrosRendimentos', index)"
                                @focus="() => focusIn('OutrosRendimentos', index)"
                                @input="event => handleInput(event, 'OutrosRendimentos', index)">

                            </div>
                            <div class="label__field" style="width: 50%">
                                <label class="label" for="outrosRendimentosOrigem">Especifique a origem dos outros
                                    rendimentos</label>
                                <input class="field" type="text" @change="salvarAlteracoesLocalmenteSocios"
                                    v-model="socio.OutrosRendimentosOrigem" id="outrosRendimentosOrigem">
                            </div>
                        </div>
                        <div class="row">
                            <div class="label__field" v-if="index > 0" style="width: 20%; margin-top: 20px">
                                <a @click.stop.prevent="excluirSocio(index)" class="ico__delete"
                                    title="Excluir sócio e acionistas">
                                    <Icon icon="ico-delete" />
                                </a>
                            </div>
                        </div>
                    </div>
                    <div class="buttonsAcoes" style="padding-bottom: 30px;">
                        <button class="btnDefault" style="width: 290px" @click="addSocio">+ Adicionar outro
                            sócio/acionista</button>
                    </div>
                </div>
            </div>
        </div>
        <div class="footerFormulario">
            <div class="buttonsAcoes">
                <button class="btnDefault" @click="salvarInformacoes" v-if="this.Edicao != true">Salvar e continuar
                    depois</button>
                <button class="btnDefault" @click="salvarInformacoes" v-if="this.Edicao == true">Salvar</button>
                <button class="btnBlue" v-if="!Edicao" @click="proximaEtapa">Avançar</button>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import api from '@/api/axios';
import viacep from '@/api/viacep';
import LabelDisclaimer from '../Utilitarios/Disclaimer/LabelDisclaimer.vue';
import Multiselect from 'vue-multiselect'
import { formatCurrency, parseCurrency, handleInput } from '@/utils/formUtils';

export default {
    name: 'CadastroPF_DadosEmpresa',
    props: ['Edicao'],
    components: {
        LabelDisclaimer,
        Multiselect
    },
    computed: {
        ...mapGetters({
            user: 'auth/user',
            infoEmpresa: 'GET_PJ_INFO_EMPRESA',
            infoComplementoEmpresa: 'GET_PJ_INFO_COMPLEMENTO_EMPRESA',
            infoComplementoSocios: 'GET_PJ_INFO_COMPLEMENTO_SOCIOS',
            empresasComplemento: 'GET_PJ_SALVAR_INFO_COMPLEMENTO_EMPRESA',
            sociosComplemento: 'GET_PJ_SALVAR_INFO_COMPLEMENTO_SOCIOS',
            listaAtividades: 'GET_LISTA_ATIVIDADES',
            listaTiposInvestidores: 'GET_LISTA_TIPOS_INVESTIDORES',
            listaTiposClientes: 'GET_LISTA_TIPOS_CLIENTES_PJ',
            salvarInformacoesPJ: 'GET_PJ_SALVAR_INFO',
            getConfiguracoes: 'GET_CONFIGURACOES',
        }),
        celularMask() {
            const telefoneLimpo = this.localPJ.Telefone?.replace(/\D/g, '');
            if (telefoneLimpo?.length <= 11) {
                return '(##) #####-####';
            }
            else {
                return '+(##) (##) ####-#####';
            }
        },
        celularMask_2() {
            const telefoneLimpo = this.localPJ.Telefone2?.replace(/\D/g, '');
            if (telefoneLimpo?.length <= 11) {
                return '(##) #####-####';
            }
            else {
                return '+(##) (##) ####-#####';
            }
        },
        selectedAtividade: {
            get() {
                return this.listaAtividades.find(atividade => atividade.id === this.localPJ.AtividadePrincipal) || null;
            },
            set(value) {
                this.localPJ.AtividadePrincipal = value ? value.id : null;
            }
        }
    },
    data() {
        return {
            permitirAvancar: false,
            tentativaPostagem: false,
            camposObrigatorios: {
                erroApelido: false,
                erroDataConstituicao: false,
                erroAtividadePrincipal: false,
                erroTipoInvestidor: false,
                erroTipoCliente: false,
                erroTelefone: false,
                erroEmail: false,
                erroFormaConstituicao: false,
            },
            camposObrigatoriosEmpresa: [],
            camposObrigatoriosSocio: [],
            localPJ: {
                Nome: null,
                Cnpj: null,
                Apelido: null,
                ApelidoOriginal: null,
                AtividadePrincipal: null,
                TipoInvestidorId: null,
                TipoClientePJId: null,
                ClienteId: null,
                DataConstituicao: null,
                Email: null,
                EmailSecundario: null,
                FormaConstituicao: null,
                NumeroNire: null,
                OutrosDescricao: null,
                Telefone: null,
                Telefone2: null
            },
            empresas: [],
            novaEmpresa: {
                Guid: '',
                ClienteId: null,
                RazaoSocial: '',
                Cnpj: '',
                Tipo: ''
            },
            socios: [{
                Guid: '',
                ClienteId: null,
                Nome: '',
                Email: '',
                Percentual: '',
                CpfCnpj: '',
                UsPerson: false,
                PoliticamenteExposta: false,
                Assinatura: '',
                Logradouro: '',
                LogradouroNumero: '',
                LogradouroComplemento: '',
                Telefone: '',
                Bairro: '',
                Cidade: '',
                Cep: '',
                Pais: '',
                Uf: '',
                RendaMensal: '',
                PatrimonioTotal: '',
                OutrosRendimentos: '',
                OutrosRendimentosOrigem: ''
            }],
            novoSocio: {
                Guid: '',
                ClienteId: null,
                Nome: '',
                Email: '',
                Percentual: '',
                CpfCnpj: '',
                UsPerson: false,
                PoliticamenteExposta: false,
                Assinatura: '',
                Logradouro: '',
                LogradouroNumero: '',
                LogradouroComplemento: '',
                Bairro: '',
                Cidade: '',
                Cep: '',
                Pais: '',
                Uf: '',
                RendaMensal: '',
                PatrimonioTotal: '',
                OutrosRendimentos: '',
                OutrosRendimentosOrigem: ''
            },
            email: '',
            mensagemErro: '',
            apelidoError: '',
            nomeEmpresa: '',
            isDisabledEndereco: true,
            configuracaoTelefone2: '',
            configuracaoApelido: '',
        };
    },
    methods: {
        ...mapActions({
            fetchConfiguracao: 'FETCH_CONFIGURACOES'
        }),
        getOptionValue(index) {
            return index + 1;
        },
        focusOut(fieldName, index) {
            this.socios[index][fieldName] = formatCurrency(this.socios[index][fieldName].toString());
        },
        focusIn(fieldName, index) {
            const value = this.socios[index][fieldName];
            this.socios[index][fieldName] = parseCurrency(value) ? parseCurrency(value).replace('.', ',') : '';
        },
        handleInput(event, fieldName, index) {
            const inputValue = event.target.value;
            this.socios[index][fieldName] = handleInput(inputValue);
        },
        converterData(dataString) {
            if (dataString && dataString !== '0001-01-01T00:00:00') {
                let data = new Date(dataString);
                let ano = data.getFullYear();
                let mes = (data.getMonth() + 1).toString().padStart(2, '0'); // adiciona um 0 à esquerda se for de 1 a 9
                let dia = data.getDate().toString().padStart(2, '0');
                return `${ano}-${mes}-${dia}`; // retorna a data no formato 'YYYY-MM-DD'
            } else {
                return null;
            }
        },
        validarApelido(event) {
            if (this.configuracaoApelido === 'S') {
                const value = event.target.value;
                const regex = /[^a-zA-Z0-9]/g;
                this.localPJ.Apelido = value.replace(regex, '').slice(0, 20);
            }
        },
        checkApelidoLength(event) {
            if ((!this.localPJ.Apelido || this.localPJ.Apelido.length < 3) && this.nomeEmpresa != 'GENIAL') {
                this.apelidoError = 'O campo apelido deve ter no mínimo três caracteres.';
                event.target.focus();
            } else {
                this.apelidoError = '';
            }
        },
        formatAtividade({ descricao }) {
            return descricao;
        },
        handleSelect(selecionado) {
            this.atualizarAtividadePrincipal(selecionado);
            this.salvarAlteracoesLocalmente();
        },
        atualizarAtividadePrincipal(selecionado) {
            this.localPJ.AtividadePrincipal = selecionado ? selecionado.id : null;
            this.salvarAlteracoesLocalmente();
        },
        proximaEtapa() {
            this.validarFormulario(true);
            if (this.permitirAvancar) {
                this.$store.commit('SET_ETAPA_CADASTRO', 1);
                this.$store.commit('SET_SALVAR_INFO_DES_NOTIFICACAO', true);
                this.salvarInformacoes();
            }
        },
        validarFormulario(submeter) {
            this.permitirAvancar = true;
            this.tentativaPostagem = submeter;
            var nomeDoCampo = '';
            this.camposObrigatorios = {
                erroApelido: false,
                erroDataConstituicao: false,
                erroAtividadePrincipal: false,
                erroTipoInvestidor: false,
                erroTipoCliente: false,
                erroTelefone: false,
                erroEmail: false,
                erroFormaConstituicao: false,
            };
            if (!this.localPJ.Apelido && this.configuracaoApelido === 'S') {
                if (submeter && this.permitirAvancar) {
                    this.camposObrigatorios.erroApelido = true;
                    nomeDoCampo = 'Apelido';
                }
                this.permitirAvancar = false;
            }
            if (!this.localPJ.DataConstituicao) {
                if (submeter && this.permitirAvancar) {
                    this.camposObrigatorios.erroDataConstituicao = true;
                    nomeDoCampo = 'Data da Constituição';
                }
                this.permitirAvancar = false;
            }
            if (!this.localPJ.AtividadePrincipal) {
                if (submeter && this.permitirAvancar) {
                    this.camposObrigatorios.erroAtividadePrincipal = true;
                    nomeDoCampo = 'Atividade Principal';
                }
                this.permitirAvancar = false;
            }
            if (!this.localPJ.TipoInvestidorId) {
                if (submeter && this.permitirAvancar) {
                    this.camposObrigatorios.erroTipoInvestidor = true;
                    nomeDoCampo = 'Tipo de Investidor';
                }
                this.permitirAvancar = false;
            }
            if (!this.localPJ.TipoClientePJId) {
                if (submeter && this.permitirAvancar) {
                    this.camposObrigatorios.erroTipoCliente = true;
                    nomeDoCampo = 'Tipo do Cliente';
                }
                this.permitirAvancar = false;
            }
            if (!this.localPJ.Telefone) {
                if (submeter && this.permitirAvancar) {
                    this.camposObrigatorios.erroTelefone = true;
                    nomeDoCampo = 'Telefone';
                }
                this.permitirAvancar = false;
            }
            if (!this.localPJ.Email) {
                if (submeter && this.permitirAvancar) {
                    this.camposObrigatorios.erroEmail = true;
                    nomeDoCampo = 'E-mail Principal';
                }
                this.permitirAvancar = false;
            }
            if (!this.localPJ.FormaConstituicao) {
                if (submeter && this.permitirAvancar) {
                    this.camposObrigatorios.erroFormaConstituicao = true;
                    nomeDoCampo = 'Forma de Constituição';
                }
                this.permitirAvancar = false;
            }
            var somaPercentual = 0;
            this.empresas.forEach((obj, index) => {
                if (!obj.RazaoSocial) {
                    this.camposObrigatoriosEmpresa[index].erroRazaoSocial = true;
                    this.permitirAvancar = false;
                    if (submeter && nomeDoCampo === '') nomeDoCampo = `Razão social da Empresa Coligada/Controlada/Controladora ${index + 1}`;
                    return;
                } else {
                    this.camposObrigatoriosEmpresa[index].erroRazaoSocial = false;
                }
                if (!obj.Cnpj) {
                    this.camposObrigatoriosEmpresa[index].erroCnpj = true;
                    this.permitirAvancar = false;
                    if (submeter && nomeDoCampo === '') nomeDoCampo = `CPF/CNPJ da EmpresaColigada/Controlada/Controladora ${index + 1}`;
                    return;
                } else {
                    this.camposObrigatoriosEmpresa[index].erroCnpj = false;
                }
            });
            this.socios.forEach((obj, index) => {
                somaPercentual += parseInt(obj.Percentual);
                if (!obj.Nome) {
                    this.camposObrigatoriosSocio[index].erroNome = true;
                    this.permitirAvancar = false;
                    if (submeter && nomeDoCampo === '') nomeDoCampo = `Nome do Sócio/Acionista ${index + 1}`;
                    return;
                } else {
                    this.camposObrigatoriosSocio[index].erroNome = false;
                }
                if (!obj.CpfCnpj) {
                    this.camposObrigatoriosSocio[index].erroCpfCnpj = true;
                    this.permitirAvancar = false;
                    if (submeter && nomeDoCampo === '') nomeDoCampo = `CPF/CNPJ do Sócio/Acionista ${index + 1}`;
                    return;
                } else {
                    this.camposObrigatoriosSocio[index].erroCpfCnpj = false;
                }

                if (!obj.Email) {
                    this.camposObrigatoriosSocio[index].erroTelefone = true;
                    this.permitirAvancar = false;
                    if (submeter && nomeDoCampo === '') nomeDoCampo = `Telefone do Sócio/Acionista ${index + 1}`;
                    return;
                } else {
                    this.camposObrigatoriosSocio[index].erroTelefone = false;
                }

                if (!obj.Email) {
                    this.camposObrigatoriosSocio[index].erroEmail = true;
                    this.permitirAvancar = false;
                    if (submeter && nomeDoCampo === '') nomeDoCampo = `E-mail do Sócio/Acionista ${index + 1}`;
                    return;
                } else {
                    this.camposObrigatoriosSocio[index].erroEmail = false;
                }
                if (!obj.Percentual) {
                    this.camposObrigatoriosSocio[index].erroPercentual = true;
                    this.permitirAvancar = false;
                    if (submeter && nomeDoCampo === '') nomeDoCampo = `Percentual do Sócio/Acionista ${index + 1}`;
                    return;
                } else {
                    this.camposObrigatoriosSocio[index].erroPercentual = false;
                }
                if (!obj.Cep) {
                    this.camposObrigatoriosSocio[index].erroCep = true;
                    this.permitirAvancar = false;
                    if (submeter && nomeDoCampo === '') nomeDoCampo = `CEP do Sócio/Acionista ${index + 1}`;
                    return;
                } else {
                    this.camposObrigatoriosSocio[index].erroCep = false;
                }
                if (!obj.Logradouro && this.isDisabledEndereco === false) {
                    this.camposObrigatoriosSocio[index].erroLogradouro = true;
                    this.permitirAvancar = false;
                    if (submeter && nomeDoCampo === '') nomeDoCampo = `Endereço/Logradouro do Sócio/Acionista ${index + 1}`;
                    return;
                } else {
                    this.camposObrigatoriosSocio[index].erroLogradouro = false;
                }
                if (!obj.LogradouroNumero) {
                    this.camposObrigatoriosSocio[index].erroLogradouroNumero = true;
                    this.permitirAvancar = false;
                    if (submeter && nomeDoCampo === '') nomeDoCampo = `Número do logradouro do Sócio/Acionista ${index + 1}`;
                    return;
                } else {
                    this.camposObrigatoriosSocio[index].erroLogradouroNumero = false;
                }
                if (!obj.Bairro && this.isDisabledEndereco === false) {
                    this.camposObrigatoriosSocio[index].erroBairro = true;
                    this.permitirAvancar = false;
                    if (submeter && nomeDoCampo === '') nomeDoCampo = `Bairro do Sócio/Acionista ${index + 1}`;
                    return;
                } else {
                    this.camposObrigatoriosSocio[index].erroBairro = false;
                }
                if (!obj.Cidade && this.isDisabledEndereco === false) {
                    this.camposObrigatoriosSocio[index].erroCidade = true;
                    this.permitirAvancar = false;
                    if (submeter && nomeDoCampo === '') nomeDoCampo = `Cidade do Sócio/Acionista ${index + 1}`;
                    return;
                } else {
                    this.camposObrigatoriosSocio[index].erroCidade = false;
                }
                if (!obj.Uf && this.isDisabledEndereco === false) {
                    this.camposObrigatoriosSocio[index].erroUf = true;
                    this.permitirAvancar = false;
                    if (submeter && nomeDoCampo === '') nomeDoCampo = `UF do Sócio/Acionista ${index + 1}`;
                    return;
                } else {
                    this.camposObrigatoriosSocio[index].erroUf = false;
                }
                if (!obj.Pais && this.isDisabledEndereco === false) {
                    this.camposObrigatoriosSocio[index].erroPais = true;
                    this.permitirAvancar = false;
                    if (submeter && nomeDoCampo === '') nomeDoCampo = `Pais do Sócio/Acionista ${index + 1}`;
                    return;
                } else {
                    this.camposObrigatoriosSocio[index].erroPais = false;
                }
                if (obj.Assinatura === null || obj.Assinatura === undefined || obj.Assinatura === '') {
                    this.camposObrigatoriosSocio[index].erroAssinatura = true;
                    this.permitirAvancar = false;
                    if (submeter && nomeDoCampo === '') nomeDoCampo = `Assinatura do Sócio/Acionista ${index + 1}`;
                    return;
                } else {
                    this.camposObrigatoriosSocio[index].erroAssinatura = false;
                }
                if (obj.RendaMensal === null || obj.RendaMensal === undefined || obj.RendaMensal === '') {
                    this.camposObrigatoriosSocio[index].erroRendaMensal = true;
                    this.permitirAvancar = false;
                    if (submeter && nomeDoCampo === '') {
                        nomeDoCampo = `Renda Mensal do Sócio/Acionista ${index + 1}`;
                    }
                    return;
                } else {
                    this.camposObrigatoriosSocio[index].erroRendaMensal = false;
                }
                if (obj.PatrimonioTotal === null || obj.PatrimonioTotal === undefined || obj.PatrimonioTotal === '') {
                    this.camposObrigatoriosSocio[index].erroPatrimonioTotal = true;
                    this.permitirAvancar = false;
                    if (submeter && nomeDoCampo === '') nomeDoCampo = `Patrimônio Total do Sócio/Acionista ${index + 1}`;
                    return;
                } else {
                    this.camposObrigatoriosSocio[index].erroPatrimonioTotal = false;
                }
            });
            if (somaPercentual > 100) {
                this.permitirAvancar = false;
                this.$swal({
                    icon: 'error',
                    title: 'Dados inválidos',
                    text: 'A soma dos percentuais pertemcentes aos sócios ultrapassa 100%.',
                });
            }
            if (submeter && nomeDoCampo != '') {
                this.$swal({
                    icon: 'warning',
                    title: 'Oops...',
                    text: `O campo ` + nomeDoCampo + ` não foi informado, preencha a informação para avançar.`,
                });
            }
        },
        // atualizarFormaConstituicao(valor) {
        //     this.localPJ.FormaConstituicao = valor;
        //     if (valor !== 'outros') {
        //         this.localPJ.OutrosDescricao = '';
        //     }
        //     this.salvarAlteracoesLocalmente();
        // },
        salvarInformacoes() {
            //this.validarFormulario(true);
            //if (this.permitirAvancar) {
            this.validarApelido({ target: { value: this.localPJ.Apelido } });
            if (this.apelidoError) {
                return false;
            }

            var sociosFormat = this.socios.map(socio => {
                if (socio.OutrosRendimentos) {
                    socio.OutrosRendimentos = socio.OutrosRendimentos.replace('R$', '').replaceAll('.', '').replaceAll(',', '.').trim();
                }
                return socio;
            });

            this.$store.commit('SET_PJ_SALVAR_INFO', true);
            this.$store.commit('SET_PJ_SALVAR_INFO_EMPRESA', this.localPJ);
            this.$store.commit('SET_PJ_SALVAR_INFO_COMPLEMENTO_EMPRESA', this.empresas);
            this.$store.commit('SET_PJ_SALVAR_INFO_COMPLEMENTO_SOCIOS', sociosFormat);
            //}
        },
        salvarAlteracoesLocalmente() {
            this.$store.commit('SET_PJ_SALVAR_INFO_EMPRESA', this.localPJ);
            this.validarFormulario();
        },
        salvarAlteracoesLocalmenteEmpresa() {
            this.$store.commit('SET_PJ_SALVAR_INFO_COMPLEMENTO_EMPRESA', this.empresas);
            this.validarFormulario();
        },
        salvarAlteracoesLocalmenteSocios() {
            this.$store.commit('SET_PJ_SALVAR_INFO_COMPLEMENTO_SOCIOS', this.socios);
            this.validarFormulario();
        },
        addEmpresa() {
            this.novaEmpresa = { Guid: '', ClienteId: this.user.ClienteId, RazaoSocial: '', Cnpj: '', Tipo: 'Coligada' };
            this.empresas.push({ ...this.novaEmpresa });
            if (!this.camposObrigatoriosEmrpesa) this.camposObrigatoriosEmrpesa = [];
            this.camposObrigatoriosEmrpesa.push({
                erroerroRazaoSocial: false,
                erroCnpj: false
            });
        },
        addSocio() {
            this.novoSocio =
            {
                Guid: '',
                ClienteId: this.user.ClienteId,
                Nome: '',
                Email: '',
                Percentual: '',
                CpfCnpj: '',
                UsPerson: false,
                PoliticamenteExposta: false,
                Assinatura: '',
                Logradouro: '',
                LogradouroNumero: '',
                LogradouroComplemento: '',
                Bairro: '',
                Cidade: '',
                Cep: '',
                Pais: '',
                Uf: '',
                RendaMensal: '',
                PatrimonioTotal: '',
                OutrosRendimentos: '',
                OutrosRendimentosOrigem: ''
            };
            this.socios.push({ ...this.novoSocio });
            if (!this.camposObrigatoriosSocio) this.camposObrigatoriosSocio = [];
            this.camposObrigatoriosSocio.push({
                erroNome: false,
                erroCpfCnpj: false,
                erroEmail: false,
                erroPercentual: false,
                erroAssinatura: false,
                erroCep: false,
                erroLogradouro: false,
                erroLogradouroNumero: false,
                erroBairro: false,
                erroCidade: false,
                erroUf: false,
                erroPais: false,
                erroRendaMensal: false,
                erroPatrimonioTotal: false
            });
        },
        async excluirEmpresa(index) {
            this.disableBtn = true;
            var encodedCredentials = btoa('sat@sat:sat23!');
            if (this.empresas[index].Guid == '') {
                this.empresas.splice(index, 1);
                return;
            }
            this.salvarAlteracoesLocalmenteEmpresa();
            await api.get(`PessoaJuridica/empresas/excluir?guid=${this.empresas[index].Guid}`, { headers: { 'Authorization': `Basic ${encodedCredentials}` } })
                .then((retorno) => {
                    if (retorno.status == 200) {
                        this.$swal({
                            icon: 'success',
                            title: 'Exclusão realizada com sucesso!',
                            text: 'Dados informados foram excluídos com sucesso.',
                        });
                        this.empresas.splice(index, 1);
                    }
                })
                .catch((error) => {
                    this.$swal({
                        icon: 'error',
                        title: 'Dados informados inválidos.',
                        text: `${error.response.data.data[0]}`,
                    });
                });
        },
        async excluirSocio(index) {
            this.disableBtn = true;
            var encodedCredentials = btoa('sat@sat:sat23!');
            if (this.socios[index].Guid == '') {
                this.socios.splice(index, 1);
                return;
            }
            await api.get(`PessoaJuridica/socios/excluir?guid=${this.socios[index].Guid}`, { headers: { 'Authorization': `Basic ${encodedCredentials}` } })
                .then((retorno) => {
                    if (retorno.status == 200) {
                        this.$swal({
                            icon: 'success',
                            title: 'Exclusão realizada com sucesso!',
                            text: 'Dados informados foram excluídos com sucesso.',
                        });
                        this.socios.splice(index, 1);
                    }
                })
                .catch((error) => {
                    this.$swal({
                        icon: 'error',
                        title: 'Dados informados inválidos.',
                        text: `${error.response.data.data[0]}`,
                    });
                });
        },
        validarEmail(email) {
            const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return regex.test(email);
        },
        validarEmailOnBlur() {
            if (this.localPJ.EmailSecundario) {
                if (!this.validarEmail(this.localPJ.EmailSecundario)) {
                    this.mensagemErro = 'E-mail inválido. Por favor, insira um e-mail válido.';
                    const input = document.getElementById('emailSecundario');
                    if (input) {
                        input.focus();
                    }
                }
                else {
                    this.mensagemErro = '';
                }
            }
            else {
                this.mensagemErro = '';
            }
        },
        inicializarCamposObrigatoriosSocio() {
            this.camposObrigatoriosSocio = this.socios.map(() => ({
                erroNome: false,
                erroCpfCnpj: false,
                erroEmail: false,
                erroPercentual: false,
                erroAssinatura: false,
                erroCep: false,
                erroLogradouro: false,
                erroLogradouroNumero: false,
                erroBairro: false,
                erroCidade: false,
                erroUf: false,
                erroPais: false,
                erroRendaMensal: false,
                erroPatrimonioTotal: false
            }));
        },
        inicializarCamposObrigatoriosEmpresa() {
            this.camposObrigatoriosEmpresa = this.empresas.map(() => ({
                erroRazaoSocial: false,
                erroCnpj: false
            }));
        },
        async validarCep() {
            this.socios.forEach(async (obj) => {
                if (obj.Cep) {
                    obj.Cep = obj.Cep.replace(/\D/g, '');
                    if (obj.Cep.length != 8) {
                        this.$swal({
                            icon: 'error',
                            title: 'Oops...',
                            text: `CEP informado está fora do padrão.`,
                        });
                        obj.Logradouro = null;
                        obj.Bairro = null;
                        obj.Cidade = null;
                        obj.Uf = null;
                        obj.Pais = null;
                        obj.Cep = null;
                        this.salvarAlteracoesLocalmente();
                        this.isDisabledEndereco = true;
                    }
                    else {
                        const { data } = await viacep.get(`/ws/${obj.Cep}/json/`);
                        if (data.erro) {
                            this.$swal({
                                icon: 'warning',
                                title: 'Oops...',
                                text: `CEP informado não foi localizado, preencha os campos manualmente.`,
                            });
                            this.isDisabledEndereco = false;
                        } else {
                            this.erro = false;
                            obj.Logradouro = data.logradouro;
                            obj.Bairro = data.bairro;
                            obj.Cidade = data.localidade;
                            obj.Uf = data.uf;
                            obj.Pais = 'Brasil';
                            this.salvarAlteracoesLocalmente();
                            if (obj.Logradouro === '' || obj.Bairro == '') {
                                this.isDisabledEndereco = false;
                            } else {
                                this.isDisabledEndereco = true;
                            }
                        }
                    }
                }
            });
        },
    },
    async created() {
        this.socios = [];
        this.$store.commit('SET_PJ_INFO_COMPLEMENTO_SOCIOS', null);
        if (this.socios[0] == null) {
            this.addSocio();
        }

        await this.fetchConfiguracao(['EXIBIR TELEFONE 2', 'Exibir apelido']);
        this.configuracaoTelefone2 = this.getConfiguracoes('EXIBIR TELEFONE 2').Valor;
        this.configuracaoApelido = this.getConfiguracoes('Exibir apelido').Valor;
    },
    mounted() {
        this.nomeEmpresa = process.env.VUE_APP_NOME_EMPRESA;
        if (this.localPJObjSalvo != null && this.localPJObjSalvo.ClienteId == this.infoEmpresa.ClienteId) {
            this.localPJ = this.localPJObjSalvo;
        }
        else {
            this.localPJ = this.infoEmpresa;
            if (this.infoEmpresa != null && this.infoEmpresa.DataConstituicao != null) {
                this.localPJ.DataConstituicao = this.converterData(this.infoEmpresa.DataConstituicao)
            }
        }
        //Empresas
        if (this.localPJObjEmpresasSalvo != null && this.localPJObjEmpresasSalvo.ClienteId == this.infoComplementoEmpresa.ClienteId) {
            this.empresas = this.localPJObjSalvo;
        }
        else if (this.infoComplementoSocios != null && this.infoComplementoSocios.length > 0) {
            this.empresas = this.infoComplementoEmpresa;
        }
        //Socios
        if (this.localObjSociosSalvo != null && this.localObjSociosSalvo.ClienteId == this.infoComplementoSocios.ClienteId) {

            var sociosFormat = this.localObjSociosSalvo.map(socio => {
                    if (socio.OutrosRendimentos) {
                        socio.OutrosRendimentos = formatCurrency(socio.OutrosRendimentos.toString().replaceAll('.', ','));
                    }
                    return socio;
            });
                
            this.socios = sociosFormat;
        }
        else if (this.infoComplementoSocios != null && this.infoComplementoSocios.length > 0) {

            var sociosFormat2 = this.infoComplementoSocios.map(socio => {
                    if (socio.OutrosRendimentos) {
                        socio.OutrosRendimentos = formatCurrency(socio.OutrosRendimentos.toString().replaceAll('.', ','));
                    }
                    return socio;
            });
                
            this.socios = sociosFormat2;

        }
        if (this.socios[0] == null) {
            this.addSocio();
        }
        this.socios[0].ClienteId = this.user.ClienteId;
        this.localPJ.Nome = this.user?.NomeRazaoSocial;
        this.inicializarCamposObrigatoriosSocio();
        this.inicializarCamposObrigatoriosEmpresa();
        this.validarFormulario();
    },
    watch: {
        infoEmpresa() {
            this.localPJ = this.infoEmpresa;
            if (this.infoEmpresa != null && this.infoEmpresa.DataConstituicao != null) {
                this.localPJ.DataConstituicao = this.converterData(this.infoEmpresa.DataConstituicao)
            }
            this.localPJ.Nome = this.user?.NomeRazaoSocial;
        },
        infoComplementoEmpresa() {
            this.empresas = this.infoComplementoEmpresa;
        },
        infoComplementoSocios() {
            if (this.infoComplementoSocios[0] != null) {
                var sociosFormat = this.infoComplementoSocios.map(socio => {

                    if (socio.OutrosRendimentos) {
                        socio.OutrosRendimentos = formatCurrency(socio.OutrosRendimentos.toString().replaceAll('.', ','));
                    }
                    return socio;
                });
                
                this.socios = sociosFormat;
            }
        },
        socios: {
            handler(newSocios) {
                this.camposObrigatoriosSocio = newSocios.map(() => ({
                    erroNome: false,
                    erroCpfCnpj: false,
                    erroEmail: false,
                    erroPercentual: false,
                    erroAssinatura: false,
                    erroCep: false,
                    erroLogradouro: false,
                    erroLogradouroNumero: false,
                    erroBairro: false,
                    erroCidade: false,
                    erroUf: false,
                    erroPais: false,
                    erroRendaMensal: false,
                    erroPatrimonioTotal: false
                }));
            },
            deep: true,
            immediate: true
        },
        empresas: {
            handler(newEmpresas) {
                this.camposObrigatoriosEmpresa = newEmpresas.map(() => ({
                    erroRazaoSocial: false,
                    erroCnpj: false
                }));
            },
            deep: true,
            immediate: true
        },
        // configuracoes(newVal) {
        //     if (newVal && newVal.Valor) {
        //         this.configuracaoTelefone2 = newVal.Valor;
        //     } else {
        //         console.error('Configurações não são válidas:', newVal);
        //         this.configuracaoTelefone2 = [];
        //     }
        // }
    }
}

</script>

<!--<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600&display=swap');

.formulario {
    width: 100%;
.formulario {
    width: 100%;
}

.agrupamentoFormulario {
    width: 100%;
    display: inline-flex;
    margin-top: 10px;
    border-bottom: 1px solid #EAECF0;
.agrupamentoFormulario {
    width: 100%;
    display: inline-flex;
    margin-top: 10px;
    border-bottom: 1px solid #EAECF0;
}

.categoriaAgrupamentoFormulario {
    width: 10%;
    margin-right: 15px;
.categoriaAgrupamentoFormulario {
    width: 10%;
    margin-right: 15px;

    h5 {
        font-family: 'Inter', sans-serif;
        /* Fonte Inter */
    }
    h5 {
        font-family: 'Inter', sans-serif;
        /* Fonte Inter */
    }
}

.label__field {
    padding-right: 30px;
.label__field {
    padding-right: 30px;
}

.camposAgrupamentoFormulario {
    width: 90%;
.camposAgrupamentoFormulario {
    width: 90%;

    .row {
        width: 100%;
        display: inline-flex;
        gap: 8px;
        margin-bottom: 10px;
    }
    .row {
        width: 100%;
        display: inline-flex;
        gap: 8px;
        margin-bottom: 10px;
    }

    .accept {
        display: inline-flex;
    .accept {
        display: inline-flex;

        &:checked {
            +label {
                &:before {
                    background: white;
                    border: 1px solid black;
                    transition: background 0.3s;
                }
            }
        &:checked {
            +label {
                &:before {
                    background: white;
                    border: 1px solid black;
                    transition: background 0.3s;
                }
            }

            +label {
                &::after {
                    opacity: 1;
                    transition: all;
                    background: transparent;
                }
            }
        }
    }
            +label {
                &::after {
                    opacity: 1;
                    transition: all;
                    background: transparent;
                }
            }
        }
    }

    .radio {
        display: flex;
        align-items: center;
        margin-right: 25px;
    .radio {
        display: flex;
        align-items: center;
        margin-right: 25px;

        @media (max-width: 768px) {
            margin-right: 0;
            margin-bottom: 20px;
        }
        @media (max-width: 768px) {
            margin-right: 0;
            margin-bottom: 20px;
        }

        .field__radio {
            width: 20px;
            height: 20px;
        }
        .field__radio {
            width: 20px;
            height: 20px;
        }

        .label__radio {
            margin-left: 5px;
            margin-right: 40px;
            margin-top: 5px;
        }
    }
        .label__radio {
            margin-left: 5px;
            margin-right: 40px;
            margin-top: 5px;
        }
    }

    select {
        width: 105% !important;
    }


    label {
        font-family: 'Inter', sans-serif;
        /* Fonte Inter */
        font-weight: 500;
        /* Peso médio */
        font-size: 14px;
        /* Tamanho da fonte */
        line-height: 20px;
        /* Altura da linha */
        color: #344054;
        /* Cor */
        display: block;
        /* Garante que a label fique acima do input */
        margin-bottom: 8px;
        /* Espaçamento entre a label e o input abaixo dela */
    }
}

.title {
    border-bottom: 1px solid #EAECF0;

    h3 {
        margin-top: 50px;
        color: #101828;
        font-weight: 500;
        font-family: 'Inter', sans-serif;
    }
    h3 {
        margin-top: 50px;
        color: #101828;
        font-weight: 500;
        font-family: 'Inter', sans-serif;
    }

    h5 {
        margin-top: 5px;
        margin-block-start: 0;
        color: #667085;
        font-weight: 400;
        font-family: 'Inter', sans-serif;
    }
    h5 {
        margin-top: 5px;
        margin-block-start: 0;
        color: #667085;
        font-weight: 400;
        font-family: 'Inter', sans-serif;
    }
}

.mensagem-erro {
    font-family: 'Inter', sans-serif;
    color: red;
    font-size: 10px;
    margin-top: 1px;
    font-weight: bold;
}
</style>-->

<style src="vue-multiselect/dist/vue-multiselect.min.css">
.multiselect__input {
    font-family: 'Inter', sans-serif;
    /* Garante a fonte Inter */
    border-radius: 8px;
    /* Raio de borda */
    border: 1px solid #d0d5dd;
    /* Borda */
    background-color: white;
    width: 100%;
    box-sizing: border-box;
}
</style>
